<template>
  <div class="attach-prods">
    <div class="wrapper">
      <div
        class="header"
        :class="showContent ? '' : 'up'"
        @click.stop="showContent = !showContent"
        v-track="{
          act: 'click',
          params: {
            event_id: customParams.cfrom_click_package,
            cfrom: customParams.cfrom_click_package,
            taskType: 1
          }
        }"
      >
        <span class="title">套餐：</span>
        <div class="mini-img-list" v-if="!showContent">
          <a v-for="(prod, index) in getImages" :key="index" :href="prod.url"><img :src="prod.img" /></a>
        </div>
        <a href="javascript:;" class="arrow">
          <v-icon v-if="showContent" name="arrow-right-order" class="g-arrow up" />
          <v-icon v-else name="arrow-right-order" class="g-arrow" />
        </a>
      </div>
      <div v-if="showContent">
        <div class="table first">
          <div class="image-box item-cell">
            <a class="figure">
              <img :src="skuUnit.commodityImgUrl" />
            </a>
          </div>
          <div class="info-box item-cell">
            <h2>
              <!-- <span v-if="skuUnit.actTagCode == 'quickBuy'" class="quickbuy-tag">V秒杀</span> -->
              <img
                class="act-tag"
                v-if="skuUnit.actTagCode == 'quickBuy'"
                :src="require(`@/assets/img/order/quickBuy.png`)"
              />
              {{ skuUnit.commodityName }}
            </h2>
            <p>
              <template v-if="skuUnit.color">颜色:{{ skuUnit.color }} &nbsp;&nbsp;</template>
              <span class="red" :class="[skuUnit.qgPrice ? 'quick-buy-red' : '']">
                <dfn>¥</dfn>
                <span>{{ skuUnit.qgPrice || skuUnit.salePrice | formatMoney }}</span>
              </span>
            </p>
          </div>
        </div>
        <div class="bundle-list" v-if="bundleExist">
          <div v-for="(bundle, index) in product.bundleUnits" :key="`bundle_${index}`" class="table">
            <div class="image-box item-cell">
              <a class="figure">
                <img :src="bundle.commodityImgUrl" alt="" />
              </a>
            </div>
            <div class="info-box item-cell">
              <h2>
                <!-- <span v-if="bundle.actTagCode == 'quickBuy'" class="quickbuy-tag">V秒杀</span> -->
                <img
                  class="act-tag"
                  v-if="bundle.actTagCode == 'quickBuy'"
                  :src="require(`@/assets/img/order/quickBuy.png`)"
                />
                {{ bundle.commodityName }}
              </h2>
              <p>
                <template v-if="bundle.color">颜色:{{ bundle.color }} &nbsp;&nbsp;</template>
                <span class="red" :class="[bundle.qgPrice ? 'quick-buy-red' : '']">
                  <dfn>¥</dfn>
                  <span>{{ bundle.qgPrice || bundle.salePrice | formatMoney }}</span>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from 'config'

export default {
  name: 'package',
  data() {
    return {
      skuUnit: this.product ? this.product.skuUnit : {},
      showContent: false,
      path: config.path
    }
  },
  props: {
    product: Object,
    // isDiscountAct: {
    //   type: Boolean,
    //   default: false
    // },
    isLastLine: {
      type: Boolean,
      default: false
    },
    customParams: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    // 套餐
    bundleExist() {
      return this.product.bundleUnits && this.product.bundleUnits.length > 0
    },
    // 是否显示左侧虚线
    // showLeftLine () {
    //   return this.isDiscountAct && !this.isLastLine
    // },
    // 获取套餐下所有可展示的图片信息
    getImages() {
      let prods = []
      prods.push({
        img: this.skuUnit.commodityImgUrl
      })
      if (this.bundleExist) {
        this.product.bundleUnits.forEach(item => {
          prods.push({
            img: item.commodityImgUrl
          })
        })
      }
      return prods
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
